import React from "react";
import ReactDom from "react-dom";
import { useLocation, useNavigate } from "react-router-dom";

const OverlayUpgrade = ({ setOpenOverlay }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPathname = location.pathname;
  return ReactDom.createPortal(
    <div className="flex flex-col fixed h-[100vh] w-[100vw] bg-opacity-30 bg-gray-400 top-0 left-0 z-[999999] backdrop-blur-sm justify-center items-center">
      <div className="flex flex-col bg-white border border-gray-200 rounded-lg p-5 max-w-[90%] md:max-w-[50%] gap-5">
        <div className="flex flex-row justify-between">
          <div className="text-lg font-semibold">
            Upgrade to individual plan 🎉
          </div>
          <div
            className="px-3 hover:bg-red-200 rounded-full cursor-pointer font-bold"
            onClick={(_) => {
              if (currentPathname.includes("/analytics")) {
                navigate("/");
              }
              setOpenOverlay(false);
            }}
          >
            x
          </div>
        </div>

        <div>
          Currently you are trying to access our premium features, you cannot
          access this unless you upgrade to our individual plan.{" "}
          <b>Let's unlock your experience</b> with our features!
        </div>
        <div className="flex flex-col w-full justify-center items-center">
          <div
            className="flex flex-col py-2 px-4 bg-secondary text-white hover:bg-primary cursor-pointer rounded-lg"
            onClick={(_) => navigate("/plan/upgrade")}
          >
            Upgrade to Individual Plan
          </div>
        </div>
      </div>
    </div>,
    document.getElementById("portal"),
  );
};

export default OverlayUpgrade;
